export const uploadConstants = {
  UPLOAD_REQUEST: "UPLOAD_REQUEST",
  UPLOAD_PROGRESS: 'UPLOAD_PROGRESS',
  UPLOAD_SUCCESS: "UPLOAD_SUCCESS",
  UPLOAD_FAILURE: "UPLOAD_FAILURE",
};
